import * as React from 'react';

declare const rootUrl: string;

interface VitaloJak2AttachSensorStepsProps {
    onNext: () => void;
}

export const VitaloJak2AttachSensorSteps = ({ onNext }: VitaloJak2AttachSensorStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Connect Microphone and Sensor</h2>
                    </div>
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>Push the data cable release catch then pull the data cable to remove.</li>
                            <li>Insert a new battery pack and plug in the connector</li>
                            <li>Feed a new chest sensor and microphone cable through the pouch</li>
                            <li>Plug the chest sensor and microphone cable into the device</li>
                            <li>Reattach the back cover and fasten it closed with the screw</li>
                        </ol>
                    </div>
                    <div className="col-md-12 text-center">
                        <img style={{ width: '100%', maxWidth: '500px' }} src={rootUrl + '/Images/Wizards/vitalojak2-3.png'} alt="" />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
            </div>
        </>
    );
}
